// Shared Tailwind class constants for the super-admin dashboard stat grids
// (formerly .stats-grid, .chart-stats-grid, .analytics-stats-grid, .payout-grid,
// .llm-stats-grid in redesign.css).

const baseGridClasses = 'grid gap-4 bg-surface';

export const statsGridClasses = `${baseGridClasses} grid-cols-4`;

export const chartStatsGridClasses = `${baseGridClasses} grid-cols-2`;

export const analyticsStatsGridClasses = `${baseGridClasses} grid-cols-4`;

export const payoutGridClasses = `${baseGridClasses} grid-cols-1`;

export const llmStatsGridClasses = `${baseGridClasses} grid-cols-1`;

// Cost summary text (formerly .cost-total-text + .cost-amount in redesign.css).
export const costTotalTextClasses =
    "text-content font-heading text-sm not-italic font-normal leading-5";

export const costAmountClasses =
    "text-content font-heading text-sm not-italic font-bold leading-5";
